import React, {Fragment, useCallback, useEffect, useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {Link, useNavigate} from 'react-router-dom'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation} from 'react-i18next'
import {
  getAllSO,
  getAllSearch,
  updateLastestProduct,
  sentToSAP,
  updateDueDate,
  cancelSO,
  getCommentSO,
} from '../../../api/modules/so'
import axios from 'axios'
import Pagination from '../component/Pagination'
import {create, getFile, deleteFile} from '../../../api/modules/file'
import swal from 'sweetalert'
import Calendar from 'react-calendar'
import {getProvince} from '../../../api/modules/getdatalist'
import {getAccesses} from '../../../api/modules/so'
import {getListBankWithCurr} from '../../../api/modules/order'
import i18next from 'i18next'
import {Spinner} from 'react-bootstrap'
import CurrencyInput from 'react-currency-input-field'
import {getSalesAreaLetter} from '../../../api/modules/getdatalist'
import './react-calendar.css'
import AddRemoveJadwal from '../si/AddRemoveJadwal'
import InputGroup from 'react-bootstrap/InputGroup'
import RowHead from './RowHead'
import RowFilter from './RowFilter'
import {ButtonGroups} from './ButtonGroups'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {PopoverText} from '../../../components/Popover/Popover'
import {objToParams} from '../../../utils/objToParams'
import {fetchSO, headers} from '../../../services/fetcher'
import {DocFlow} from '../../../components/DocFlow'
import {getRoleFlagList} from '../../../api/modules/master-data/master_2'
import {MultiSelect} from 'react-multi-select-component'
import * as TableUI from '../../../components/Table/Table'
import {useRowTable} from '../../../hooks/useRowTable'
import {filterSelector, setIsFetchData} from '../../../redux/slices/filterSlices'
import {StyledCard} from '../../../components/StyledCard'
import {PriceFormater} from '../../../components/mikro/PriceFormater'
import {HakAkses} from '../../../components/mikro/getHakAkses'
import {authSelector} from 'src/redux/slices/authSlices'
import {BadgeColorSO} from 'src/components/BadgeColorSO'
import dateformat from 'src/utils/dateformat'
import {CheckSameIDAttachment} from 'src/components/mikro/CheckSameIDAttachment'
import {FieldProductSpec} from 'src/components/FieldProductSpec'
import {SkeletonModal} from 'src/components'
import { concatIncoterm } from 'src/app/helpers/concat'
import { InputFile } from 'src/app/components/InputFile'
import { handleDownloadAttachment } from 'src/app/helpers/file'

type Props = {
  className: string
}

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

const SOTable: React.FC<Props> = ({className}) => {
  const navigate = useNavigate()
  const [tooltip, setTooltip] = useState('Open')
  const {roleId} = useAppSelector(authSelector)
  const {filterSO: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const hakAkses = HakAkses()
  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 16,
    onReloadTable: () => handleReloadTable(),
  })

  const isRetail = (sector: any): boolean => (sector == 2 || sector == 4)

  const handleOpen = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('iconArow')) {
      icon?.classList.remove('iconArow')
      icon?.classList.add('iconArowOpen')
      setTooltip('Close')
    } else {
      icon?.classList.remove('iconArowOpen')
      icon?.classList.add('iconArow')
      setTooltip('Open')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    fold?.classList.toggle('fold-open')
  }

  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)
  const [show5, setShow5] = useState(false)
  const [showUpload, setShowUpload] = useState(false)
  const [showDate, setShowDate] = useState(false)
  const [isFailed, setIsFailed] = useState(false)
  const [lastDate, setLastDate] = useState<any>('')
  const [tanggal, setTanggal] = useState<any>('')
  const [bulan, setBulan] = useState<any>('')
  const [tahun, setTahun] = useState<any>('')
  const handleClose5 = () => setShow5(false)
  const handleShow5 = () => setShow5(true)

  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)

  //#region
  const [SOData, setSOData] = useState<any[]>([])
  const [fullRole, setFullRole] = useState<any[]>([])
  const [tempRole, setTempRole] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [numberURL, setNumberURL] = useState([])
  const [files, setFiles] = useState({file: null})
  const [allFile, setAllFiles] = useState<any[]>([])
  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')
  const [idItem, setIDItem] = useState(0)
  const [param, setParam] = useState('')
  const [date, setDate] = useState<Value>(new Date())
  const [showJadwal, setShowJadwal] = useState(false)
  const [orderSubID, setOrderSubID] = useState(0)
  const [tempID, setTempID] = useState(0)
  const [tipeProduct, setTipeProduct] = useState('')
  const [unitProduct, setUnitProduct] = useState('')
  const [tempDetail, setTempDetail] = useState<any>([])
  const [showDetail, setShowDetail] = useState(false)
  const [quantumSO, setQuantumSO] = useState(0)
  //#endregion
  const [dateNow, setDateNow] = useState('')
  const [loadingDownload, setLoadingDownload] = useState(false)
  const [language, setLanguage] = useState<any>()
  const [downloadOnly, setDownloadOnly] = useState(false)
  const [SONumber, setSONumber] = useState('')
  const [fileBox, setFileBox] = useState<any>({})
  const [isFetching, setIsFetching] = useState(true)
  const [fetchingError, setFetchingError] = useState('')

  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  const [dateType, setDateType] = useState('')

  const handleDate = (tanggal: any, type: any) => {
    let temp = tanggal.slice(0, 10)
    let temp2 = temp.split('-')
    setDateType(type)
    setTanggal(parseInt(temp2[2]))
    setBulan(parseInt(temp2[1]) - 1)
    setTahun(parseInt(temp2[0]))

    const munculEdit = setTimeout(() => {
      setShowDate(true)
    }, 2000)
    return () => clearTimeout(munculEdit)
  }

  const dateFormatting = (date: any) => {
    if (date == null) return ''
    else {
      let today = new Date(date)
      let dd = String(today.getDate()).padStart(2, '0')
      let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
      let yyyy = today.getFullYear()
      return dd + '-' + mm + '-' + yyyy
    }
  }

  const resendToSAP = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (confirm: any) => {
      if (confirm) {
        setLoading(true)
        await sentToSAP(id)
          .then((res) => {
            swal({
              title: `${t('Already Sent to SAP')}`,
              icon: 'success',
            }).then(() => {
              const getData = async () => {
                setLoading(true)
                await getAllSearch(
                  localStorage.getItem('credential')!,
                  filter?.so_number ?? '',
                  filter?.sap_number ?? '',
                  filter?.incoterm ?? '',
                  filter?.sector_id ?? '',
                  filter?.sales_org_code ?? '',
                  filter?.booking_code ?? '',
                  filter?.total_quantum_so ?? '',
                  filter?.from_date ?? '',
                  filter?.to_date ?? '',
                  filter?.status ?? '',
                  filter?.po_number ?? '',
                  filter?.customer_name ?? '',
                  filter?.total_price_so ?? '',
                  filter?.sip_number ?? '',
                  filter?.price_after_ppn ?? '',
                  filter?.product_type ?? '',
                  filter?.payment_type ?? ''
                )
                  .then((res: any) => {
                    setSOData(res.data.data.data)
                    setNumberURL(res.data.data.links)
                  })
                  .catch((err: any) => {
                    setIsFailed(true)
                  })
                  .finally(() => {
                    setLoading(false)
                  })
              }
              getData()
            })
          })
          .catch((err: any) => {
            swal({
              title: `${t(err.response.data.message)}`,
              icon: 'error',
            })
          })
          .finally(() => setLoading(false))
      }
    })
  }

  const clearInputUpload = () => {
    const input1 = document.getElementById('uploadketerangan') as HTMLInputElement
    input1.value = ''
    const input2 = document.getElementById('upload') as HTMLInputElement
    input2.value = ''
    const inputPrivate = document.getElementById('isPrivate') as HTMLInputElement
    inputPrivate.checked = false
    // const input3 = document.getElementById("uploadnama") as HTMLInputElement
    // input3.value = ''
    // const input4 = document.getElementById("uploadjenis") as HTMLInputElement
    // input4.value = t('Select file type')
  }

  const removeFileState = () => {
    setFiles({file: null})
    setNamaFile('')
    setDescription('')
    setDataType('')
    setTempRole([])
    setIsPrivate(false)
  }

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    })
      .then(async (willDelete) => {
        if (willDelete) {
          await deleteFile(id)
            .then(() => {
              swal({
                closeOnClickOutside: false,
                title: t('Dokumen Berhasil Dihapus'),
                icon: 'success',
              })
              ambilAttachment(idItem, param)
            })
            .catch((error) => {
              swal({
                title: error.response.data,
                icon: 'error',
              })
            })
        }
      })
      .catch((err: any) => {
        swal({
          title: `${t(err.response.data.message)}`,
          icon: 'error',
        })
      })
  }

  const handleUpload = async (id: any) => {
    setBtnLoading(true)
    let file = files.file
    let formdata = new FormData()
    let temparray: any[] = []
    if (tempRole.length > 0) {
      tempRole.forEach((data: any) => {
        temparray.push(data.value)
      })
    }
    formdata.append('file_r', file!)
    formdata.append('name', namaFile!)
    formdata.append('description', description!)
    formdata.append('attach_parent', id!)
    formdata.append('file_type', dataType)
    formdata.append('private', isPrivate.toString())
    formdata.append('roles', JSON.stringify(temparray))
    formdata.append('credentials', localStorage.getItem('credential')!)
    // if(param == 'order-item' && sektorId != 2){
    // formdata.append('unique_number', SONumber)
    // formdata.append('unique_flag', 'new_so_osd')
    // }

    await create(param, formdata)
      .then((res: any) => {
        if (!res.data.error) {
          swal({
            title: `${t('document uploaded successfully')}`,
            icon: 'success',
          })
          ambilAttachment(id, param)
          removeFileState()
          clearInputUpload()
        } else {
          swal({
            title: t(res.data.message),
            icon: 'error',
          })
        }
      })
      .catch(function (error) {
        if (error) {
          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        }
      })
    setBtnLoading(false)
  }

  const handleTanggal = async () => {
    let tahun = '';
    let bulan = '';
    let hari = '';

    if(date instanceof Date){
      tahun = String(date.getFullYear())
      bulan = String(date.getMonth() + 1)
      hari = String(date.getDate())
    }
    setBtnLoading(true)
    if (dateType == 'lastest') {
      await updateLastestProduct(tempID, {
        latest_date_pick_up: tahun + '-' + bulan.padStart(2, '0') + '-' + hari.padStart(2, '0'),
      })
        .then((res: any) => {
          if (!res.data.error) {
            swal({
              title: `${t('dataBerhasilDiupload')}`,
              icon: 'success',
            }).then(() => {
              setShowDate(false)
              const getData = async () => {
                setLoading(true)
                await getAllSearch(
                  localStorage.getItem('credential')!,
                  filter?.so_number ?? '',
                  filter?.sap_number ?? '',
                  filter?.incoterm ?? '',
                  filter?.sector_id ?? '',
                  filter?.sales_org_code ?? '',
                  filter?.booking_code ?? '',
                  filter?.total_quantum_so ?? '',
                  filter?.from_date ?? '',
                  filter?.to_date ?? '',
                  filter?.status ?? '',
                  filter?.po_number ?? '',
                  filter?.customer_name ?? '',
                  filter?.total_price_so ?? '',
                  filter?.sip_number ?? '',
                  filter?.price_after_ppn ?? '',
                  filter?.product_type ?? '',
                  filter?.payment_type ?? ''
                )
                  .then((resp: any) => {
                    setSOData(resp.data.data.data)
                    setNumberURL(resp.data.data.links)
                  })
                  .catch((err: any) => {
                    setIsFailed(true)
                  })
                  .finally(() => {
                    setLoading(false)
                    setDateType('')
                  })
              }
              getData()
            })
          } else {
            swal({
              title: res.data.message,
              icon: 'error',
            })
          }
        })
        .catch(function (error) {
          if (error) {
            swal({
              title: t('dataGagalDiSubmit'),
              icon: 'error',
            })
          }
        })
        .finally(() => setBtnLoading(false))
    } else if (dateType == 'duedate') {
      await updateDueDate(tempID, {
        payment_due_date: tahun + '-' + bulan.padStart(2, '0') + '-' + hari.padStart(2, '0'),
      })
        .then((res: any) => {
          if (!res.data.error) {
            swal({
              title: `${t('dataBerhasilDiupload')}`,
              icon: 'success',
            }).then(() => {
              setShowDate(false)
              const getData = async () => {
                setLoading(true)
                await getAllSearch(
                  localStorage.getItem('credential')!,
                  filter?.so_number ?? '',
                  filter?.sap_number ?? '',
                  filter?.incoterm ?? '',
                  filter?.sector_id ?? '',
                  filter?.sales_org_code ?? '',
                  filter?.booking_code ?? '',
                  filter?.total_quantum_so ?? '',
                  filter?.from_date ?? '',
                  filter?.to_date ?? '',
                  filter?.status ?? '',
                  filter?.po_number ?? '',
                  filter?.customer_name ?? '',
                  filter?.total_price_so ?? '',
                  filter?.sip_number ?? '',
                  filter?.price_after_ppn ?? '',
                  filter?.product_type ?? '',
                  filter?.payment_type ?? ''
                )
                  .then((resp: any) => {
                    setSOData(resp.data.data.data)
                    setNumberURL(resp.data.data.links)
                  })
                  .catch((err: any) => {
                    setIsFailed(true)
                  })
                  .finally(() => {
                    setLoading(false)
                    setDateType('')
                  })
              }
              getData()
            })
          } else {
            swal({
              title: res.data.message,
              icon: 'error',
            })
          }
        })
        .catch(function (error) {
          if (error) {
            swal({
              title: t(error.response.data.message),
              icon: 'error',
            })
          }
        })
        .finally(() => setBtnLoading(false))
    }
    setBtnLoading(false)
  }

  const ambilAttachment = async (id: any, paramm: any) => {
    try {
      setIsFetching(true)
      setFetchingError('')

      const res = await getFile(paramm, id, localStorage.getItem('credential')!)

      setAllFiles(res.data.data)
    } catch (error: any) {
      const errMessage = error?.response?.data?.message ?? 'Internal server error'
      setFetchingError(errMessage)
    } finally {
      setIsFetching(false)
    }
  }

  const handleShowAttachment = (data: any) => {
    let tmp: any[] = []
    let idUser = localStorage?.getItem('user-id')
    data.forEach((item: any) => {
      if (item.private) {
        if (hakAkses?.attachment) {
          return tmp.push(item)
        } else if (idUser == item.user_id) {
          return tmp.push(item)
        } else {
        }
      } else {
        return tmp.push(item)
      }
    })
    setAllFiles(tmp)
  }

  const [roleUser, setRoleUser] = useState('')

  const findPPN = (before: 0, after: 0) => {
    let ppn = 0.0
    ppn = ((after - before) / before) * 100
    return ppn
  }

  const [bank, setBank] = useState<any[]>([])
  const [accesses, setAccesses] = useState<any>()
  const [province, setProvince] = useState([])
  const [filterAsc, setFilterAsc] = useState<any>('')
  const [filterCus, setFilterCus] = useState<any>('')

  /** @deprecated gunakan onFetchSO */
  const getOrder = async () => {
    setLoading(true)
    setIsFailed(false)
    await getAllSO(localStorage.getItem('credential'), filterAsc, filterCus)
      .then((response: any) => {
        setSOData(response.data.data.data)
        setNumberURL(response.data.data.links)
      })
      .catch((err: any) => {
        setIsFailed(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const onFetchSO = useCallback(() => {
    setLoading(true)
    setIsFailed(false)

    fetchSO({... filter, user_update: (hakAkses?.approve && hakAkses.update ? 'true' : '')})
      .then((res) => {
        setSOData(res.data.data.data)
        setNumberURL(res.data.data.links)
      })
      .catch(() => setIsFailed(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filter])

  const [salesOrg, setSalesOrg] = useState<any>()

  useEffect(() => {
    const ProvinceData = async () => {
      await getProvince().then((res: any) => {
        setProvince(res.data.data)
      })
    }

    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }

    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccesses(roleId)
      setAccesses(res.data.data)
    }

    const getBank = async () => {
      setLoading(true)
      const res = await getListBankWithCurr()
      setBank(res.data.data)
    }

    const getSalesOrg = async () => {
      const res = await getSalesAreaLetter()
      setSalesOrg(res.data.data)
    }

    let today = new Date()
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    setDateNow(dd + '-' + mm + '-' + yyyy)

    const getAllRoleList = async () => {
      const res = await getRoleFlagList()
      setFullRole(res.data.data)
    }

    getSalesOrg()
    ProvinceData()
    getBank()
    getAccessMenu()
    role()
    getAllRoleList()
  }, [])

  const paginateNumber = async (url: any) => {
    if (!url) return
    setLoading(true)

    const token = localStorage.getItem('token') as string
    const credentials = localStorage.getItem('credential') as string
    const endpoint = `${url}&credentials=${credentials}&${objToParams({...filter, user_update: hakAkses?.approve && hakAkses.update ? 'true' : ''})}`
    const res = await axios.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})

    setSOData(res.data.data.data)
    setLoading(false)
    setNumberURL(res.data.data.links)
  }

  const goToDetail = (id: any, status = null) => {
    console.log(status, roleUser)
    if(status == 2 && roleUser == 'salesAnper'){
      navigate('/management/so/revise/'+id)
      return
    }
    sessionStorage.setItem('id', id)
    navigate('/management/so/detail')
  }

  const [bookingCode, setBookingCode] = useState<any>('')
  const [pengirim, setPengirim] = useState<any>('')
  const [currency, setCurrency] = useState<any>()
  const [loadingBank, setLoadingBank] = useState(false)
  const [bankId, setBankId] = useState<any>()
  const [tanggalPembayaran, setTanggalPembayaran] = useState<any>('')
  const [amount, setAmount] = useState<any>('')

  useEffect(() => {
    const getBank = async () => {
      try{
        setLoadingBank(true)
        const res = await getListBankWithCurr(currency)
        setBank(res.data.data)
        setLoadingBank(false)
      }catch{
        setLoadingBank(false)
      }
    }

    getBank();
  }, [currency]);

  const postBank = async () => {
    setBtnLoading(true)
    axios
      .put(
        `${
          process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT
        }/sales-order/clearing-payment?credentials=${localStorage.getItem('credential')}`,
        {
          booking_code: bookingCode,
          pengirim: pengirim,
          bank: bankId,
          tanggal_pembayaran: tanggalPembayaran,
          amount: amount,
          currency: currency,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((response) => {
        handleClose5()
        swal({
          title: `${t('Payment successfully')}`,
          icon: 'success',
        }).then(() => {
          setActived(!actived)
          onFetchSO()
          setLoading(false)
        })
      })
      .catch((error) => {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const [showEdit, setShowEdit] = useState(false)
  const [quantityEdit, setQuantityEdit] = useState<any>()
  const [plantEdit, setPlantEdit] = useState<any>('')
  const [plantDescEdit, setPlantDescEdit] = useState<any>('')
  const [slocEdit, setSlocEdit] = useState<any>('')
  const [slocDescriptionEdit, setSlocDescriptionEdit] = useState<any>('')
  const [priceEdit, setPriceEdit] = useState<any>('')
  const [idEdit, setIdEdit] = useState<any>('')
  const [sectorId, setsectorId] = useState<any>()
  const [loadingModal, setLoadingModal] = useState(false)
  const [sektorId, setSektorId] = useState(0)
  const [provinceName, setProvinceName] = useState('')
  const [cityName, setCityName] = useState('')
  const [productName, setProductName] = useState('')
  const [fixedQuantum, setFixedQuantum] = useState('')
  const [fullcomment, setFullComment] = useState<any[]>([])
  const [showCommentCust, setShowCommentCust] = useState(false)

  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }
    setFixedQuantum(temp)
  }

  const handleEditSoItem = (
    quantity: any,
    plant: any,
    plantDesc: any,
    sloc: any,
    slocDescription: any,
    price: any,
    id: any,
    sector: any
  ) => {
    setLoadingModal(true)
    setQuantityEdit(quantity)
    setPlantEdit(plant)
    setPlantDescEdit(plantDesc)
    setSlocEdit(sloc)
    setSlocDescriptionEdit(slocDescription)
    setPriceEdit(price)
    setIdEdit(id)
    setLoadingModal(false)
    setsectorId(sector)
    setShowEdit(true)
  }

  const submitEdit = async () => {
    setBtnLoading(true)
    axios
      .put(
        `${
          process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT
        }/sales-order/so-item/${idEdit}?credentials=${localStorage.getItem('credential')}`,
        {
          quantity: quantityEdit,
          plant: plantEdit,
          plant_desc: plantDescEdit,
          sloc: slocEdit,
          sloc_description: slocDescriptionEdit,
          price: parseFloat(priceEdit),
          lang: i18next.language,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((res) => {
        setBtnLoading(false)
        swal({
          title: `${t('success updating data')}`,
          icon: 'success',
        }).then(async () => {
          setShowEdit(false)
          setLoading(true)
          await getAllSearch(
            localStorage.getItem('credential')!,
            filter?.so_number ?? '',
            filter?.sap_number ?? '',
            filter?.incoterm ?? '',
            filter?.sector_id ?? '',
            filter?.sales_org_code ?? '',
            filter?.booking_code ?? '',
            filter?.total_quantum_so ?? '',
            filter?.from_date ?? '',
            filter?.to_date ?? '',
            filter?.status ?? '',
            filter?.po_number ?? '',
            filter?.customer_name ?? '',
            filter?.total_price_so ?? '',
            filter?.sip_number ?? '',
            filter?.price_after_ppn ?? '',
            filter?.product_type ?? '',
            filter?.payment_type ?? ''
          )
            .then((res: any) => {
              setSOData(res.data.data.data)
              setNumberURL(res.data.data.links)
            })
            .catch((err: any) => {
              setIsFailed(true)
            })
            .finally(() => {
              setLoading(false)
            })
        })
      })
      .catch((err) => {
        const msg = err.response.data.message.message || err.response.data.message
        swal({
          title: `${t(msg)}`,
          icon: 'error',
        })
      })
      .finally(() => {
        setLoading(false)

        setBtnLoading(false)
      })
  }

  const batalSO = async (id: any) => {
    setBtnLoading(true)
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (accept) => {
      if (accept) {
        await cancelSO(id)
          .then((res: any) => {
            swal({
              title: `${t('SO berhasil dibatalkan')}`,
              icon: 'success',
            }).then(() => {
              setBtnLoading(false)
              const getData = async () => {
                setLoading(true)
                await getAllSearch(
                  localStorage.getItem('credential')!,
                  filter?.so_number ?? '',
                  filter?.sap_number ?? '',
                  filter?.incoterm ?? '',
                  filter?.sector_id ?? '',
                  filter?.sales_org_code ?? '',
                  filter?.booking_code ?? '',
                  filter?.total_quantum_so ?? '',
                  filter?.from_date ?? '',
                  filter?.to_date ?? '',
                  filter?.status ?? '',
                  filter?.po_number ?? '',
                  filter?.customer_name ?? '',
                  filter?.total_price_so ?? '',
                  filter?.sip_number ?? '',
                  filter?.price_after_ppn ?? '',
                  filter?.product_type ?? '',
                  filter?.payment_type ?? ''
                )
                  .then((resp: any) => {
                    setSOData(resp.data.data.data)
                    setNumberURL(resp.data.data.links)
                  })
                  .catch((err: any) => {
                    setIsFailed(true)
                  })
                  .finally(() => {
                    setLoading(false)
                    setDateType('')
                  })
              }
              getData()
            })
          })
          .catch((err: any) => {
            swal({
              title: `${t(err.response.data.message)}`,
              icon: 'error',
            })
          })
          .finally(() => {
            setBtnLoading(false)
          })
      } else {
        setBtnLoading(false)
      }
    })
  }

  const handleCheckFile = (url: any) => {
    axios
      .get(url)
      .then((response) => {
        window.open(url)
      })
      .catch((error) => {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
  }

  const toDownloadSO = (id: any, cond: any) => {
    if (hakAkses?.print) {
      const lang = i18next.language
      if (cond == 'sap')
        handleCheckFile(
          `${
            process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT
          }/sales-order/print/so/${id}?lang=${lang}&token=${localStorage.getItem('token')}`
        )
      else if (cond == 'booking')
        handleCheckFile(
          `${
            process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT
          }/sales-order/print/booking_code/${lang}/${id}?token=${localStorage.getItem('token')}`
        )
    }
  }

  //#region state for search
  const [actived, setActived] = useState(false)

  useEffect(() => {
    const getData = setTimeout(onFetchSO, 1000)
    return () => clearTimeout(getData)
  }, [onFetchSO])
  //#endregion

  const handleDownload = async () => {
    setLoadingDownload(true)
    let data = {
      booking_code: filter.booking_code || undefined,
      customer_name: filter.customer_name || undefined,
      customer_name_orderby: filter.customer_name_orderby || undefined,
      from_date: filter.from_date || undefined,
      incoterm: filter.incoterm || undefined,
      payment_type: filter.payment_type || undefined,
      po_number: filter.po_number || undefined,
      po_number_orderby: filter.po_number_orderby || undefined,
      price_after_ppn: filter.price_after_ppn || undefined,
      product_type: filter.product_type || undefined,
      sales_org_code: filter.sales_org_code || undefined,
      sap_number: filter.sap_number || undefined,
      sector_id: filter.sector_id || undefined,
      sip_number: filter.sip_number || undefined,
      so_number: filter.so_number || undefined,
      status: filter.status || undefined,
      to_date: filter.to_date || undefined,
      total_price_so: filter.total_price_so || undefined,
      total_quantum_so: filter.total_quantum_so || undefined,
      credentials: localStorage.getItem('credential'),
    }

    try {
      const res = await axios({
        url: `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/sales-order/export`,
        method: 'GET',
        params: data,
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      })
      const href = URL.createObjectURL(res.data)
      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', `PI_Sales_Order_${dateNow}.xlsx`)
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(href)
      setLoadingDownload(false)
    } catch {
      swal({
        title: t('Export Failed'),
        icon: 'error',
      })
      setLoadingDownload(false)
    }
  }

  const handleFormat = (data: any) => {
    let value = data?.replace(/,/g, '.')
    return value
  }

  const handleShowValue = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  const handleGetComment = (id: any) => {
    setIsFetchData(true)
    getCommentSO(id)
      .then((res) => {
        setFullComment(res.data.data)
        setIsFetchData(false)
        setIsFetching(false)
        setShowCommentCust(true)
      })
  }

  const [filterActive, setFilterActive] = useState('true')

  const handleReloadTable = () => {
    // dispatch(resetFilterSO())
    onFetchSO()
  }

  useEffect(() => {
    return () => {
      handleReloadTable()
    }
  }, [])

  function handleShowRoleName(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  return (
    <StyledCard>
      {roleUser == 'null' && (
        <>
          <ButtonGroups role={roleUser} hasCreateContractAccess onReloadTable={handleReloadTable} />
          <TableUI.TableWrapper>
            <TableUI.Table>
              <TableUI.THead>
                <RowHead role={roleUser} />
              </TableUI.THead>
              <TableUI.TBody>
                <RowFilter role={roleUser} />
                {loading ? (
                  <RowLoader />
                ) : isFailed ? (
                  <RowErrorFetch />
                ) : SOData.length === 0 ? (
                  <RowEmptyData />
                ) : (
                  SOData.map((item, _index) => (
                    <Fragment key={item?.id ?? _index}>
                      <tr>
                        <td>
                          <div
                            className='d-flex justify-content-center align-items-center p-2'
                            style={{marginTop: '3px', marginBottom: '2.5px'}}
                          >
                            <button
                              className='iconArow d-flex justify-content-center align-items-center me-2'
                              data-target={'target' + item['id']}
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t(tooltip)}
                              onClick={handleOpen}
                            ></button>
                            <p>{item['id']}</p>
                          </div>
                        </td>
                        <td>
                          <Link className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              to={('/management/so/detail/' + parseInt(item['so_number']))}>
                            13{item['so_number']}
                          </Link>
                        </td>
                        <td>
                          <Link className='fw-bold cursor-pointer hover-underline'
                                style={{color: '#274070'}}
                                to={('/management/order/detail/' + parseInt(item?.order_sub?.po_number))}>
                            10{item?.order_sub?.po_number}
                          </Link>
                        </td>
                        <td>
                          {(item.booking_code == null || ([0,1,2].includes(item.status))) ? (
                            <span className='d-block fs-6 text-transparent'>-</span>
                          ) : (
                            <span
                              className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              onClick={() => toDownloadSO(item.id, 'booking')}
                            >
                              {item.booking_code}
                            </span>
                          )}
                        </td>
                        <td>
                          {item.sap_number != null && (item.status == 6 || item.status == 7) ? (
                            <span
                              className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              onClick={() => toDownloadSO(item.id, 'sap')}
                            >
                              {item['sap_number']}
                            </span>
                          ) : (
                            <span className='d-block fs-6'>-</span>
                          )}
                        </td>
                        <td>
                          <span className='d-block fs-6'>
                            <PopoverText
                              content={
                                item['customer']?.title == null || item['customer']?.title == ''
                                  ? item['customer']?.name
                                  : item['customer']?.title + ' ' + item['customer']?.name
                              }
                              index={_index}
                              className='desc-slicee'
                            />
                          </span>
                        </td>
                        {isRetail(item?.sector_id) ? (
                          <td>
                              {item?.sip_order?.SIP_number
                                ? <>
                                  11{item?.sip_order?.SIP_number}
                                  {/* <Link className='fw-bold cursor-pointer hover-underline'
                                style={{color: '#274070'}}
                                to={('/management/si/detail/' + parseInt(item?.sip_order?.SIP_number))}>
                                </Link> */}
                                </>
                                : ''}
                          </td>
                        ) : (
                          <td>
                              {item?.contract?.sip_order?.SIP_number
                                ? 
                                <>
                                {/* <Link className='fw-bold cursor-pointer hover-underline'
                                style={{color: '#274070'}}
                                to={('/management/si/detail/' + parseInt(item?.contract?.sip_order?.SIP_number))}> */}
                                  11{item?.contract?.sip_order?.SIP_number}
                                {/* </Link> */}
                                </>
                                : ''}
                          </td>
                        )}
                        <td>
                          <span className='d-block fs-6'>{item.anper?.name}</span>
                        </td>
                        <td>
                          <span className='d-block fs-6'>{t(item.sector?.name)}</span>
                        </td>
                        <td>
                          {item.create_so_sap_date == null || item.create_so_sap_date == '' ? (
                            <span className='d-block fs-6 text-transparent'>-</span>
                          ) : (
                            <span className='d-block fs-6'>
                              {dateformat(item.create_so_sap_date)}
                            </span>
                          )}
                        </td>
                        <td>
                          <span className='d-block fs-6'>
                            <PopoverText
                              content={item?.product_types ? item?.product_types : '-'}
                              index={_index}
                              className='desc-slice'
                            />
                          </span>
                        </td>
                        <td>
                          <span className='d-block fs-6'>
                            {(i18next.language === 'en'
                              ? parseFloat(item.detail_quantity?.total_tonnase)?.toLocaleString(
                                  'en',
                                  {maximumFractionDigits: 4}
                                )
                              : parseFloat(item.detail_quantity?.total_tonnase)?.toLocaleString(
                                  'id',
                                  {maximumFractionDigits: 4}
                                )) + (item?.sector_id === 3 ? ' MT' : ' Ton')}
                          </span>
                        </td>
                        <td>
                          <span className='d-block fs-6'>
                            {(item.sector_id != 3 ? 'Rp ' : 'USD ') +
                              (i18next.language === 'en'
                                ? item.price_after_ppn?.toLocaleString('en', {
                                    maximumFractionDigits: 4,
                                  })
                                : item.price_after_ppn?.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  }))}
                          </span>
                        </td>
                        <td>
                          <span className='fw-semibold d-block fs-6'>
                            <PopoverText
                              content={
                                item?.payment?.payment_desc ? item?.payment?.payment_desc : '-'
                              }
                              index={_index}
                              className='desc-slice'
                            />
                          </span>
                        </td>
                        <td>
                          <BadgeColorSO
                            text={item.status_text}
                            status={item.status}
                            role={roleUser}
                            approved_level={item?.approved_level}
                          />
                        </td>
                        <td>
                          <div
                            className='d-flex justify-content-center align-items-center p-0'
                            style={{marginTop: '1.3px', marginBottom: '1px'}}
                          >
                            <Link
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title='Detail'
                              to={('/management/so/detail/' + parseInt(item['so_number']))}>
                                <KTSVG
                                  path='/media/icons/duotune/file-text-fill.svg'
                                  className='svg-icon-3'
                                />
                            </Link>
                            <button
                              onClick={() => {
                                setParam('sales-order')
                                ambilAttachment(item.id, 'sales-order')
                                setIDItem(item.id)
                                setShowUpload(true)
                              }}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('order-lampiran')}
                            >
                              <KTSVG
                                path='/media/icons/duotune/archive-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                            {item.sap_number != null && (
                              <button
                                onClick={() =>
                                  handleCheckFile(
                                    `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/sales-order/print/proforma-invoice/${item.id}?lang=${i18next.language}`
                                  )
                                }
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Proforma Invoice')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/printer-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            )}
                            <button
                              onClick={() => {
                                handleGetComment(item.id)
                              }}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              hidden={hakAkses?.read ? false : true}
                              title={t('Comment')}
                            >
                              <KTSVG
                                path='/media/icons/duotune/chat-left-text-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          </div>
                        </td>
                      </tr>

                      <tr className='fold' id={'target' + item['id']}>
                        <TableUI.TableDetail colSpan={16}>
                          <TableUI.TableWrapper style={{marginBottom: 0}}>
                            <TableUI.Table>
                              <TableUI.THead>
                                <tr style={{backgroundColor: '#274070'}}>
                                  <th>{t('kontrak-item')}</th>
                                  <th>Sales Org</th>
                                  <th>{t('kontrak-incoterm')}</th>
                                  <th>{t('kontrak-wilayah')}</th>
                                  {(item?.sector_id == 1 || item?.sector_id == 3) && (<th>{t('sub-order-endUser')}</th>)}
                                  <th>{t('Product Type')}</th>
                                  <th>{t('Product Code')}</th>
                                  <th>{t('Product Name')}</th>
                                  <th>{t('quantumapproved')}</th>
                                  {!isRetail(item.sector_id) ? <th>{t('Shipping Tolerance')}</th> : ''}
                                  <th>{t('quantumso')}</th>
                                  <th>{t('quantumsisa')}</th>
                                  <th>{t('quantumrealized')}</th>
                                  <th>{t('Price')}</th>
                                  <th>{t('kontrak-hargaPPN')}</th>
                                  <th>{t('kontrak-ppn')}</th>
                                  <th>{t('kontrak-hargaSPPN')}</th>
                                  <th>{t('Plant')}</th>
                                  <th>{t('Route')}</th>
                                  <th>Status</th>
                                  <th className='text-center'>{t('order-aksi')}</th>
                                </tr>
                              </TableUI.THead>
                              <TableUI.TBody>
                                {item['so_items']?.map((subItem: any, index: any) => (
                                  <tr key={subItem?.id ?? index}>
                                    <td>{index + 1}</td>
                                    <td>{subItem.order_sub_detail?.produsen?.name}</td>
                                    {isRetail(subItem.order_sub_detail?.sector?.id) ? (
                                      <>
                                        {subItem.incoterm2 == null ? (
                                          <td className='text-center td2-freeze'>
                                            {subItem.incoterm1?.code}
                                          </td>
                                        ) : (
                                          <td className='text-center td2-freeze'>
                                            {subItem.incoterm1?.code}-{subItem.incoterm2}
                                          </td>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {subItem.incoterm2 == null ? (
                                          <td className='text-center td2-freeze'>
                                            {subItem.incoterm1?.code}
                                            {subItem.incoterm2 == null
                                              ? ''
                                              : '-' + subItem.incoterm2}
                                          </td>
                                        ) : (
                                          <td className='text-center td2-freeze'>
                                            {subItem.incoterm1?.code}-{subItem.incoterm2}
                                          </td>
                                        )}
                                      </>
                                    )}
                                    <td>
                                      {subItem.order_sub_detail?.province?.region_name}
                                      {subItem.order_sub_detail?.city?.city_name
                                        ? ', ' + subItem.order_sub_detail?.city?.city_name
                                        : ''}
                                    </td>
                                    {(item?.sector_id == 1 || item?.sector_id == 3) && (
                                      <td>
                                        <div>
                                          <PopoverText
                                            content={subItem?.order_sub_detail?.end_user}
                                            index={index}
                                            className='desc-slicee'
                                          />
                                        </div>
                                      </td>
                                    )}
                                    <td>{subItem.order_sub_detail?.product_type_desc}</td>
                                    <td>
                                      {parseInt(subItem.order_sub_detail?.material_number) == 0
                                        ? ''
                                        : subItem.order_sub_detail?.material_number?.slice(-7)}
                                    </td>
                                    <td>{subItem.order_sub_detail?.product_name}</td>
                                    <td>
                                      {i18next.language === 'en'
                                        ? subItem?.order_sub_detail?.quantum_contract?.toLocaleString(
                                            'en',
                                            {maximumFractionDigits: 4}
                                          )
                                        : subItem?.order_sub_detail?.quantum_contract?.toLocaleString(
                                            'id',
                                            {maximumFractionDigits: 4}
                                          )}{' '}
                                      {subItem.order_sub_detail?.product_type != '8105'
                                        ? subItem?.order_sub_detail?.sector_id === 3
                                          ? ' MT'
                                          : ' Ton'
                                        : subItem?.order_sub_detail?.unit}
                                    </td>
                                    {!isRetail(item.sector_id) ? (
                                      <td>
                                        {subItem.order_sub_detail?.shipping_tolerance == 0
                                          ? ''
                                          : subItem.order_sub_detail?.shipping_tolerance + '%'}
                                      </td>
                                    ) : (
                                      ''
                                    )}
                                    <td>
                                      {i18next.language === 'en'
                                        ? subItem?.quantity?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : subItem?.quantity?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}{' '}
                                      {subItem.order_sub_detail?.product_type != '8105'
                                        ? subItem?.order_sub_detail?.sector_id === 3
                                          ? ' MT'
                                          : ' Ton'
                                        : subItem?.order_sub_detail?.unit}
                                    </td>
                                    <td>
                                      {i18next.language === 'en'
                                        ? subItem?.order_sub_detail?.left_over_quantum_no_st?.toLocaleString(
                                            'en',
                                            {maximumFractionDigits: 4}
                                          )
                                        : subItem?.order_sub_detail?.left_over_quantum_no_st?.toLocaleString(
                                            'id',
                                            {maximumFractionDigits: 4}
                                          )}{' '}
                                      {subItem.order_sub_detail?.product_type != '8105'
                                        ? subItem?.order_sub_detail?.sector_id === 3
                                          ? ' MT'
                                          : ' Ton'
                                        : subItem?.order_sub_detail?.unit}
                                    </td>
                                    <td>
                                      {i18next.language === 'en'
                                        ? subItem?.order_sub_detail?.so_qty_realized?.toLocaleString(
                                            'en',
                                            {maximumFractionDigits: 4}
                                          )
                                        : subItem?.order_sub_detail?.so_qty_realized?.toLocaleString(
                                            'id',
                                            {maximumFractionDigits: 4}
                                          )}{' '}
                                      {subItem.order_sub_detail?.product_type != '8105'
                                        ? subItem.order_sub_detail?.sector_id != 3
                                          ? 'Ton'
                                          : 'MT'
                                        : subItem?.order_sub_detail?.unit}
                                    </td>
                                    <td>
                                      {subItem.price == 0 || subItem.price == null ? (
                                        <>
                                          {(subItem.sector_id != 3 ? 'Rp ' : 'USD ') +
                                            (i18next.language === 'en'
                                              ? subItem?.order_sub_detail?.fixed_price?.toLocaleString(
                                                  'en',
                                                  {maximumFractionDigits: 4}
                                                )
                                              : subItem?.order_sub_detail?.fixed_price?.toLocaleString(
                                                  'id',
                                                  {maximumFractionDigits: 4}
                                                ))}
                                        </>
                                      ) : (
                                        <>
                                          {(subItem.sector_id != 3 ? 'Rp ' : 'USD ') +
                                            (i18next.language === 'en'
                                              ? subItem?.price?.toLocaleString('en', {
                                                  maximumFractionDigits: 4,
                                                })
                                              : subItem?.price?.toLocaleString('id', {
                                                  maximumFractionDigits: 4,
                                                }))}
                                        </>
                                      )}
                                      /
                                      {subItem.order_sub_detail?.product_type != '8105'
                                        ? subItem.sector_id != 3
                                          ? 'Ton'
                                          : 'MT'
                                        : subItem?.order_sub_detail?.unit}
                                    </td>
                                    <td>
                                      {(subItem.sector_id != 3 ? 'Rp ' : 'USD ') +
                                        (i18next.language === 'en'
                                          ? subItem.price_before_ppn?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : subItem.price_before_ppn?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }))}
                                    </td>
                                    <td>{subItem.ppn}%</td>
                                    <td>
                                      {(subItem.sector_id != 3 ? 'Rp ' : 'USD ') +
                                        (i18next.language === 'en'
                                          ? subItem.price_after_ppn?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : subItem.price_after_ppn?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }))}
                                    </td>
                                    <td>{subItem.plant + " - " + subItem.plant_desc}</td>
                                    <td>{subItem.route_desc}</td>
                                    <td>
                                      <BadgeColorSO
                                        text={subItem.status_text}
                                        status={subItem.status}
                                        role={roleUser}
                                        approved_level={item?.approved_level}
                                      />
                                    </td>
                                    <td>
                                      <div className='d-flex justify-content-center'>
                                        <button
                                          onClick={() => {
                                            setTempDetail(subItem)
                                            setShowDetail(true)
                                          }}
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          title='Detail'
                                          hidden={hakAkses?.read ? false : true}
                                        >
                                          <KTSVG
                                            path='/media/icons/duotune/file-text-fill.svg'
                                            className='svg-icon-3'
                                          />
                                        </button>
                                        <button
                                          onClick={() => {
                                            setFileBox(subItem.order_sub_detail)
                                            setParam('so-item')
                                            ambilAttachment(subItem?.id, 'so-item')
                                            setSektorId(subItem.order_sub_detail.sector_id)
                                            setSONumber(item.so_number)
                                            setIDItem(subItem?.id)
                                            setShowUpload(true)
                                          }}
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          title={t('order-lampiran')}
                                        >
                                          <KTSVG
                                            path='/media/icons/duotune/archive-fill.svg'
                                            className='svg-icon-3'
                                          />
                                        </button>
                                        {item.order_sub.regarding == 'PO001' ? (
                                          <button
                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                            title={t('Jadwal')}
                                            onClick={() => {
                                              setTipeProduct(subItem.order_sub_detail.product_type)
                                              setUnitProduct(subItem.order_sub_detail.unit)
                                              setSektorId(subItem.order_sub_detail.sector_id)
                                              setProvinceName(
                                                subItem.order_sub_detail.province?.region_name
                                              )
                                              setCityName(subItem.order_sub_detail.city?.city_name)
                                              setProductName(subItem.order_sub_detail.product_name)
                                              formattingTon(subItem.order_sub_detail.fixed_quantum)
                                              setOrderSubID(
                                                subItem.order_sub_detail.order_sub_item_id == null
                                                  ? subItem.order_sub_detail?.id
                                                  : subItem.order_sub_detail?.order_sub_item_id
                                              )
                                              setShowJadwal(true)
                                            }}
                                          >
                                            <KTSVG
                                              path='/media/icons/duotune/calendar-check-fill.svg'
                                              className='svg-icon-3'
                                            />
                                          </button>
                                        ) : (
                                          ''
                                        )}
                                        <DocFlow
                                          id={
                                            subItem.order_sub_detail.order_sub_item_id == null
                                              ? subItem.order_sub_detail?.id
                                              : subItem.order_sub_detail?.order_sub_item_id
                                          }
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </TableUI.TBody>
                            </TableUI.Table>
                          </TableUI.TableWrapper>
                        </TableUI.TableDetail>
                      </tr>
                    </Fragment>
                  ))
                )}
              </TableUI.TBody>
            </TableUI.Table>
          </TableUI.TableWrapper>
        </>
      )}

      {['salesAnper', 'salesAdmin', 'otorisator', 'admin'].includes(roleUser) && (
        <>
          <ButtonGroups
            role={roleUser}
            hasCreateContractAccess={hakAkses?.create}
            hasExportAccess
            onDownload={handleDownload}
            isDownloadLoading={loadingDownload}
            onReloadTable={handleReloadTable}
            onCreateClearingManual={roleUser == 'admin' ? handleShow5 : undefined}
          />
          <TableUI.TableWrapper>
            <TableUI.Table>
              <TableUI.THead>
                <RowHead role={roleUser} />
              </TableUI.THead>
              <TableUI.TBody>
                <RowFilter role={roleUser} />
                {loading ? (
                  <RowLoader />
                ) : isFailed ? (
                  <RowErrorFetch />
                ) : SOData.length === 0 ? (
                  <RowEmptyData />
                ) : (
                  SOData.map((item, _index) => (
                    <Fragment key={_index}>
                      <tr
                        className={
                          item.status == 0 && (hakAkses?.update && hakAkses?.approve) && item.approved_level == 0
                            ? 'bg-kuning'
                            : ''
                        }
                      >
                        <td>
                          <div className='d-flex justify-content-center align-items-center p-2'>
                            <button
                              className='iconArow d-flex justify-content-center align-items-center me-2'
                              data-target={'target' + item['id']}
                              title={t(tooltip)}
                              onClick={handleOpen}
                            ></button>
                            <p>{item['id']}</p>
                          </div>
                        </td>
                        <td>
                          <Link className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              to={(item.status == 2 && roleUser == 'salesAnper') ? ('/management/so/revise/' + parseInt(item['so_number'])) : ('/management/so/detail/' + parseInt(item['so_number']))}>
                            13{item['so_number']}
                          </Link>
                        </td>
                        <td>
                          <Link className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              to={('/management/order/detail/' + parseInt(item?.order_sub?.po_number))}>
                            10{item?.order_sub?.po_number}
                          </Link>
                        </td>
                        <td>
                          {(item.booking_code == null || ([0,1,2].includes(item.status))) ? (
                            <span>-</span>
                          ) : (
                            <span
                              className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              onClick={() => toDownloadSO(item.id, 'booking')}
                            >
                              {item.booking_code}
                            </span>
                          )}
                        </td>
                        <td>
                          {item.sap_number != null && (item.status == 6 || item.status == 7) ? (
                            <span
                              className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              onClick={() => toDownloadSO(item.id, 'sap')}
                            >
                              {item['sap_number']}
                            </span>
                          ) : (
                            <span className='d-block fs-6'>-</span>
                          )}
                        </td>
                        <td>
                          <PopoverText
                            content={
                              item['customer']?.title == null || item['customer']?.title == ''
                                ? item['customer']?.name
                                : item['customer']?.title + ' ' + item['customer']?.name
                            }
                            index={_index}
                            className='desc-slicee'
                          />
                        </td>
                        {isRetail(item?.sector_id) ? (
                          <td>
                            {item?.sip_order?.SIP_number ? <>
                              <Link className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              to={('/management/sip/detail/' + parseInt(item?.sip_order?.SIP_number))}>
                            11{item?.sip_order?.SIP_number}
                          </Link>
                            </> : ''}
                          </td>
                        ) : (
                          <td>
                            {item?.contract?.sip_order?.SIP_number
                              ? <>
                              <Link className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              to={('/management/sip/detail/' + parseInt(item?.contract?.sip_order?.SIP_number))}>
                            11{item?.contract?.sip_order?.SIP_number}
                          </Link>
                              </>
                              : ''}
                          </td>
                        )}
                        <td>
                          <span>{item['anper']?.name}</span>
                        </td>
                        <td>
                          <span>{t(item.sector?.name)}</span>
                        </td>
                        <td>
                          {item.create_so_sap_date ? (
                            <span>{dateformat(item.create_so_sap_date)}</span>
                          ) : (
                            <span>-</span>
                          )}
                        </td>
                        <td>
                          <PopoverText
                            content={item?.product_types ? item?.product_types : '-'}
                            index={_index}
                            className='desc-slice'
                          />
                        </td>
                        <td>
                          {(i18next.language === 'en'
                            ? parseFloat(item.detail_quantity?.total_tonnase)?.toLocaleString(
                                'en',
                                {
                                  maximumFractionDigits: 4,
                                }
                              )
                            : parseFloat(item.detail_quantity?.total_tonnase)?.toLocaleString(
                                'id',
                                {
                                  maximumFractionDigits: 4,
                                }
                              )) + (item?.sector_id === 3 ? ' MT' : ' Ton')}
                        </td>

                        <td>
                          <span>
                            {(item.sector_id != 3 ? 'Rp ' : 'USD ') +
                              (i18next.language === 'en'
                                ? item.price_after_ppn?.toLocaleString('en', {
                                    maximumFractionDigits: 4,
                                  })
                                : item.price_after_ppn?.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  }))}
                          </span>
                        </td>
                        <td>
                          <PopoverText
                            content={
                              item?.payment?.payment_desc ? item?.payment?.payment_desc : '-'
                            }
                            index={_index}
                            className='desc-slice'
                          />
                        </td>
                        <td>
                          <BadgeColorSO
                            text={item.status_text}
                            status={item.status}
                            role={roleUser}
                            approved_level={item?.approved_level}
                          />
                        </td>
                        <td>
                          <div
                            className='d-flex justify-content-center align-items-center p-0'
                            style={{marginTop: '1.3px', marginBottom: '1px'}}
                          >
                            <Link
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              title='Detail'
                              hidden={hakAkses?.read ? false : true}
                              style={{color: '#274070'}}
                              to={(item.status == 2 && roleUser == 'salesAnper') ? ('/management/so/revise/' + parseInt(item['so_number'])) : ('/management/so/detail/' + parseInt(item['so_number']))}>
                                <KTSVG
                                  path='/media/icons/duotune/file-text-fill.svg'
                                  className='svg-icon-3'
                                />
                            </Link>
                            <button
                              onClick={() => {
                                setParam('sales-order')
                                ambilAttachment(item.id, 'sales-order')
                                setIDItem(item.id)
                                setShowUpload(true)
                              }}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              title={t('order-lampiran')}
                            >
                              <KTSVG
                                path='/media/icons/duotune/archive-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                            {item.sap_number != null &&
                            hakAkses?.update &&
                            item.status != 13 ? (
                              <button
                                onClick={() => {
                                  handleDate(item.lates_date_pick_up, 'lastest')
                                  setTempID(item.id)
                                }}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                title={t('changedate')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/calendar2-event.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            ) : (
                              ''
                            )}
                            {(item.status == 99 || item.status == 9) &&
                            hakAkses?.update ? (
                              <button
                                onClick={() => {
                                  handleDate(item.payment_due_date, 'duedate')
                                  setTempID(item.id)
                                }}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                title={t('Update Due Date')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/calendar2-week-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            ) : (
                              ''
                            )}
                            {item.status == '13' && hakAkses?.update ? (
                              <button
                                onClick={() => resendToSAP(item['id'])}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                title={t('sentSAP')}
                              >
                                <i className='fas fa-sync-alt'></i>
                              </button>
                            ) : (
                              ''
                            )}
                            {(hakAkses?.delete && [0,1,9].includes(item?.status)) ? (
                              <button
                                onClick={() => {
                                  batalSO(item.id)
                                }}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                title={t('cancelSO')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/x-circle-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            ) : (
                              ''
                            )}
                            {hakAkses?.print && item.sap_number != null && (
                              <button
                                onClick={() =>
                                  handleCheckFile(
                                    `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/sales-order/print/proforma-invoice/${item.id}?lang=${i18next.language}`
                                  )
                                }
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                title={t('Proforma Invoice')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/printer-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            )}
                            <button
                              onClick={() => {
                                handleGetComment(item.id)
                              }}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              title={t('Comment')}
                              hidden={hakAkses?.read ? false : true}
                            >
                              <KTSVG
                                path='/media/icons/duotune/chat-left-text-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          </div>
                        </td>
                      </tr>

                      <tr className='fold' id={'target' + item['id']}>
                        <TableUI.TableDetail colSpan={16}>
                          <TableUI.TableWrapper style={{marginBottom: 0}}>
                            <TableUI.Table>
                              <TableUI.THead>
                                <tr style={{backgroundColor: '#274070'}}>
                                  <th>{t('kontrak-item')}</th>
                                  <th>Sales Org</th>
                                  <th>{t('kontrak-incoterm')}</th>
                                  <th>{t('kontrak-wilayah')}</th>
                                  {(item?.sector_id == 1 || item?.sector_id == 3) && (<th>{t('sub-order-endUser')}</th>)}
                                  <th>{t('Product Type')}</th>
                                  <th>{t('Product Code')}</th>
                                  <th>{t('Product Name')}</th>
                                  <th>{t('quantumapproved')}</th>
                                  {!isRetail(item.sector_id) ? <th>{t('Shipping Tolerance')}</th> : ''}
                                  <th>{t('quantumso')}</th>
                                  <th>{t('quantumsisa')}</th>
                                  <th>{t('quantumrealized')}</th>
                                  <th>{t('Price')}</th>
                                  <th>{t('kontrak-hargaPPN')}</th>
                                  <th>{t('kontrak-ppn')}</th>
                                  <th>{t('kontrak-hargaSPPN')}</th>
                                  <th>{t('Plant')}</th>
                                  <th>{t('Route')}</th>
                                  <th>Status</th>
                                  <th>{t('order-aksi')}</th>
                                </tr>
                              </TableUI.THead>
                              <TableUI.TBody>
                                {item['so_items']?.map((subItem: any, index: any) => (
                                  <tr key={subItem?.id ?? index}>
                                    <td>{index + 1}</td>
                                    <td>{subItem.order_sub_detail?.produsen?.name}</td>
                                    <td>{ concatIncoterm(
                                      subItem.incoterm1 || subItem.incoterm1_id,
                                      subItem.incoterm2 || subItem.incoterm2_id,
                                    ) }</td>
                                    <td>
                                      {subItem.order_sub_detail?.province?.region_name}
                                      {subItem.order_sub_detail?.city?.city_name
                                        ? ', ' + subItem.order_sub_detail?.city?.city_name
                                        : ''}
                                    </td>
                                    {(item?.sector_id == 1 || item?.sector_id == 3) && (
                                      <td>
                                        <div>
                                          <PopoverText
                                            content={subItem?.order_sub_detail?.end_user}
                                            index={index}
                                            className='desc-slicee'
                                          />
                                        </div>
                                      </td>
                                    )}
                                    <td>{subItem.order_sub_detail?.product_type_desc}</td>
                                    <td>
                                      {parseInt(subItem.order_sub_detail?.material_number) == 0
                                        ? ''
                                        : subItem.order_sub_detail?.material_number?.slice(-7)}
                                    </td>
                                    <td>{subItem.order_sub_detail?.product_name}</td>
                                    <td>
                                      {i18next.language === 'en'
                                        ? parseInt(subItem?.order_sub_detail?.quantum_contract)?.toLocaleString(
                                            'en',
                                            {maximumFractionDigits: 4}
                                          )
                                        : parseInt(subItem?.order_sub_detail?.quantum_contract)?.toLocaleString(
                                            'id',
                                            {maximumFractionDigits: 4}
                                          )}{' '}
                                      {subItem.order_sub_detail?.product_type != '8105'
                                        ? subItem?.order_sub_detail?.sector_id === 3
                                          ? 'MT'
                                          : 'Ton'
                                        : subItem?.order_sub_detail?.unit}
                                    </td>

                                    {!isRetail(item.sector_id) ? (
                                      <td>
                                        {subItem.order_sub_detail?.shipping_tolerance == 0
                                          ? ''
                                          : subItem.order_sub_detail?.shipping_tolerance + '%'}
                                      </td>
                                    ) : (
                                      ''
                                    )}
                                    <td>
                                      {i18next.language === 'en'
                                        ? subItem?.quantity?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : subItem?.quantity?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}{' '}
                                      {subItem.order_sub_detail?.product_type != '8105'
                                        ? subItem?.order_sub_detail?.sector_id === 3
                                          ? 'MT'
                                          : 'Ton'
                                        : subItem?.order_sub_detail?.unit}
                                    </td>

                                    <td>
                                      {i18next.language === 'en'
                                        ? subItem?.order_sub_detail?.left_over_quantum_no_st?.toLocaleString(
                                            'en',
                                            {maximumFractionDigits: 4}
                                          )
                                        : subItem?.order_sub_detail?.left_over_quantum_no_st?.toLocaleString(
                                            'id',
                                            {maximumFractionDigits: 4}
                                          )}{' '}
                                      {subItem.order_sub_detail?.product_type != '8105'
                                        ? subItem?.order_sub_detail?.sector_id === 3
                                          ? 'MT'
                                          : 'Ton'
                                        : subItem?.order_sub_detail?.unit}
                                    </td>
                                    <td>
                                      {i18next.language === 'en'
                                        ? subItem?.order_sub_detail?.so_qty_realized?.toLocaleString(
                                            'en',
                                            {maximumFractionDigits: 4}
                                          )
                                        : subItem?.order_sub_detail?.so_qty_realized?.toLocaleString(
                                            'id',
                                            {maximumFractionDigits: 4}
                                          )}{' '}
                                      {subItem.order_sub_detail?.product_type != '8105'
                                        ? subItem?.order_sub_detail?.sector_id === 3
                                          ? 'MT'
                                          : 'Ton'
                                        : subItem?.order_sub_detail?.unit}
                                    </td>
                                    <td>
                                      {subItem.price == 0 || subItem.price == null ? (
                                        <>
                                          {(item.sector_id != 3 ? 'Rp ' : 'USD ') +
                                            (i18next.language === 'en'
                                              ? subItem?.order_sub_detail?.fixed_price?.toLocaleString(
                                                  'en',
                                                  {maximumFractionDigits: 4}
                                                )
                                              : subItem?.order_sub_detail?.fixed_price?.toLocaleString(
                                                  'id',
                                                  {maximumFractionDigits: 4}
                                                ))}
                                        </>
                                      ) : (
                                        <>
                                          {(item.sector_id != 3 ? 'Rp ' : 'USD ') +
                                            (i18next.language === 'en'
                                              ? subItem?.price?.toLocaleString('en', {
                                                  maximumFractionDigits: 4,
                                                })
                                              : subItem?.price?.toLocaleString('id', {
                                                  maximumFractionDigits: 4,
                                                }))}
                                        </>
                                      )}
                                      /{' '}
                                      {subItem.order_sub_detail?.product_type != '8105'
                                        ? item.sector_id != 3
                                          ? 'Ton'
                                          : 'MT'
                                        : subItem?.order_sub_detail?.unit}
                                    </td>
                                    <td>
                                      {(item.sector_id != 3 ? 'Rp ' : 'USD ') +
                                        (i18next.language === 'en'
                                          ? subItem.price_before_ppn?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : subItem.price_before_ppn?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }))}
                                    </td>
                                    <td>{subItem?.ppn ? subItem?.ppn + '%' : '0%'}</td>
                                    <td>
                                      {(item.sector_id != 3 ? 'Rp ' : 'USD ') +
                                        (i18next.language === 'en'
                                          ? subItem.price_after_ppn?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : subItem.price_after_ppn?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }))}
                                    </td>
                                    <td>{subItem.plant + " - " + subItem.plant_desc}</td>
                                    <td>{subItem.route_desc} {item?.approved_level}</td>
                                    <td>
                                      <BadgeColorSO
                                        text={subItem.status_text}
                                        status={subItem.status}
                                        role={roleUser}
                                        approved_level={item?.approved_level}
                                      />
                                    </td>
                                    <td>
                                      <div className='d-flex justify-content-center'>
                                        <button
                                          onClick={() => {
                                            setTempDetail(subItem)
                                            setShowDetail(true)
                                          }}
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          data-bs-toggle='tooltip'
                                          data-bs-placement='top'
                                          data-bs-trigger='hover'
                                          title='Detail'
                                          hidden={hakAkses?.read ? false : true}
                                        >
                                          <KTSVG
                                            path='/media/icons/duotune/file-text-fill.svg'
                                            className='svg-icon-3'
                                          />
                                        </button>
                                        <button
                                          onClick={() => {
                                            setFileBox(subItem.order_sub_detail)
                                            setParam('so-item')
                                            ambilAttachment(subItem?.id, 'so-item')
                                            setSektorId(subItem.order_sub_detail.sector_id)
                                            setSONumber(item.so_number)
                                            setIDItem(subItem?.id)
                                            setShowUpload(true)
                                          }}
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          data-bs-toggle='tooltip'
                                          data-bs-placement='top'
                                          data-bs-trigger='hover'
                                          title={t('order-lampiran')}
                                        >
                                          <KTSVG
                                            path='/media/icons/duotune/archive-fill.svg'
                                            className='svg-icon-3'
                                          />
                                        </button>
                                        {item.order_sub.regarding == 'PO001' ? (
                                          <button
                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                            data-bs-toggle='tooltip'
                                            data-bs-placement='top'
                                            data-bs-trigger='hover'
                                            title={t('Jadwal')}
                                            onClick={() => {
                                              setTipeProduct(subItem.order_sub_detail.product_type)
                                              setUnitProduct(subItem.order_sub_detail.unit)
                                              setSektorId(subItem.order_sub_detail.sector_id)
                                              setProvinceName(
                                                subItem.order_sub_detail.province?.region_name
                                              )
                                              setCityName(subItem.order_sub_detail.city?.city_name)
                                              setProductName(subItem.order_sub_detail.product_name)
                                              formattingTon(subItem.order_sub_detail.fixed_quantum)
                                              setOrderSubID(
                                                subItem.order_sub_detail?.order_sub_item_id == null
                                                  ? subItem.order_sub_detail?.id
                                                  : subItem.order_sub_detail?.order_sub_item_id
                                              )
                                              setShowJadwal(true)
                                            }}
                                          >
                                            <KTSVG
                                              path='/media/icons/duotune/calendar-check-fill.svg'
                                              className='svg-icon-3'
                                            />
                                          </button>
                                        ) : (
                                          ''
                                        )}

                                        {/* {(subItem.order_sub_detail.sector_id == 1 ||
                                          subItem.order_sub_detail.sector_id == 3) &&
                                        item.payment_type != 'E' &&
                                        item.payment_type != 'EP' &&
                                        item?.status == 6 &&
                                        roleUser == 'salesAnper' &&
                                        (subItem.order_sub_detail.product_type == 'P13' ||
                                          subItem.order_sub_detail.product_type == 'P01' ||
                                          subItem.order_sub_detail.product_type == 'P02') ? (
                                          <button
                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                            data-bs-toggle='tooltip'
                                            data-bs-placement='top'
                                            data-bs-trigger='hover'
                                            title={t('ubah')}
                                            onClick={() => {
                                              let price = 0
                                              if (subItem.price == null || subItem.price == 0)
                                                price = subItem.order_sub_detail?.fixed_price
                                              else price = subItem.price
                                              handleEditSoItem(
                                                subItem.quantity,
                                                subItem.plant,
                                                subItem.plant + " - " + subItem.plant_desc,
                                                subItem.sloc,
                                                subItem.sloc_description,
                                                price,
                                                subItem?.id,
                                                item?.sector_id
                                              )
                                            }}
                                          >
                                            <KTSVG
                                              path='/media/icons/duotune/pencil-fill.svg'
                                              className='svg-icon-3'
                                            />
                                          </button>
                                        ) : (
                                          <></>
                                        )} */}
                                        <DocFlow
                                          id={
                                            subItem.order_sub_detail.order_sub_item_id == null
                                              ? subItem.order_sub_detail?.id
                                              : subItem.order_sub_detail?.order_sub_item_id
                                          }
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </TableUI.TBody>
                            </TableUI.Table>
                          </TableUI.TableWrapper>
                        </TableUI.TableDetail>
                      </tr>
                    </Fragment>
                  ))
                )}
              </TableUI.TBody>
            </TableUI.Table>
          </TableUI.TableWrapper>
        </>
      )}

      {roleUser == 'finance' && (
        <>
          <ButtonGroups
            role={roleUser}
            hasExportAccess
            isDownloadLoading={loadingDownload}
            onReloadTable={handleReloadTable}
            onDownload={handleDownload}
            onCreateClearingManual={handleShow5}
          />
          <TableUI.TableWrapper>
            <TableUI.Table>
              <TableUI.THead>
                <RowHead role={roleUser} />
              </TableUI.THead>
              <TableUI.TBody>
                <RowFilter role={roleUser} />
                {loading ? (
                  <RowLoader />
                ) : isFailed ? (
                  <RowErrorFetch />
                ) : SOData.length === 0 ? (
                  <RowEmptyData />
                ) : (
                  SOData.map((item, _index) => (
                    <Fragment key={_index}>
                      <tr>
                        <td>
                          <div className='d-flex justify-content-center align-items-center p-2'>
                            <button
                              className='iconArow d-flex justify-content-center align-items-center me-2'
                              data-target={'target' + item['id']}
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t(tooltip)}
                              onClick={handleOpen}
                            ></button>
                            <p>{item['id']}</p>
                          </div>
                        </td>
                        <td>
                          <Link className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              to={('/management/so/detail/' + parseInt(item['so_number']))}>
                            13{item['so_number']}
                          </Link>
                        </td>
                        <td>
                          <Link className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              to={('/management/order/detail/' + parseInt(item?.order_sub?.po_number))}>
                            10{item?.order_sub?.po_number}
                          </Link>
                        </td>
                        <td>
                          {(item.booking_code == null || ([0,1,2].includes(item.status))) ? (
                            <span className='d-block fs-6'>-</span>
                          ) : (
                            <span
                              className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              onClick={() => toDownloadSO(item.id, 'booking')}
                            >
                              {item.booking_code}
                            </span>
                          )}
                        </td>
                        <td>
                          {item.sap_number !== null && (item.status == 6 || item.status == 7) ? (
                            <span
                              className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              onClick={() => toDownloadSO(item.id, 'sap')}
                            >
                              {item['sap_number']}
                            </span>
                          ) : (
                            <span className='d-block fs-6'>-</span>
                          )}
                        </td>
                        <td>
                          <PopoverText
                            content={
                              item['customer']?.title == null || item['customer']?.title == ''
                                ? item['customer']?.name
                                : item['customer']?.title + ' ' + item['customer']?.name
                            }
                            index={_index}
                            className='desc-slicee'
                          />
                        </td>
                        {item?.sector_id == 2 ? (
                          <td>
                            {item?.sip_order?.SIP_number ? <>
                              <Link className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              to={('/management/sip/detail/' + parseInt(item?.sip_order?.SIP_number))}>
                            11{item?.sip_order?.SIP_number}
                          </Link>
                            </> : ''}
                          </td>
                        ) : (
                          <td>
                            {item?.contract?.sip_order?.SIP_number
                              ? <>
                              <Link className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              to={('/management/sip/detail/' + parseInt(item?.contract?.sip_order?.SIP_number))}>
                            11{item?.contract?.sip_order?.SIP_number}
                          </Link>
                              </>
                              : ''}
                          </td>
                        )}
                        <td>{item['anper']?.name}</td>
                        <td>{t(item.sector?.name)}</td>
                        <td>
                          {item.create_so_sap_date ? (
                            <span className='d-block fs-6'>
                              {dateformat(item.create_so_sap_date)}
                            </span>
                          ) : (
                            <span className='d-block fs-6 text-transparent'>-</span>
                          )}
                        </td>
                        <td>
                          <PopoverText
                            content={item?.product_types ? item?.product_types : '-'}
                            index={_index}
                            className='desc-slice'
                          />
                        </td>
                        <td>
                          {i18next.language === 'en'
                            ? parseFloat(item.detail_quantity?.total_tonnase)?.toLocaleString(
                                'en',
                                {
                                  maximumFractionDigits: 4,
                                }
                              )
                            : parseFloat(item.detail_quantity?.total_tonnase)?.toLocaleString(
                                'id',
                                {
                                  maximumFractionDigits: 4,
                                }
                              ) + (item?.sector_id === 3 ? ' MT' : ' Ton')}
                        </td>
                        <td>
                          {(item.sector_id != 3 ? 'Rp' : 'USD') +
                            (i18next.language === 'en'
                              ? item.price_after_ppn?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : item.price_after_ppn?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }))}
                        </td>
                        <td>
                          <PopoverText
                            content={
                              item?.payment?.payment_desc ? item?.payment?.payment_desc : '-'
                            }
                            index={_index}
                            className='desc-slice'
                          />
                        </td>
                        <td>
                          <BadgeColorSO
                            text={item.status_text}
                            status={item.status}
                            role={roleUser}
                            approved_level={item?.approved_level}
                          />
                        </td>
                        <td>
                          <div
                            className='d-flex justify-content-center align-items-center p-0'
                            style={{marginTop: '1.3px', marginBottom: '1px'}}
                          >
                            <Link
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                title='Detail'
                                hidden={hakAkses?.read ? false : true}
                                to={('/management/so/detail/' + parseInt(item['so_number']))}>
                                <KTSVG
                                  path='/media/icons/duotune/file-text-fill.svg'
                                  className='svg-icon-3'
                                />
                            </Link>
                            <button
                              onClick={() => {
                                setParam('sales-order')
                                ambilAttachment(item.id, 'sales-order')
                                setIDItem(item.id)
                                setShowUpload(true)
                              }}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              title={t('order-lampiran')}
                            >
                              <KTSVG
                                path='/media/icons/duotune/archive-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                            {item.status == '13' && hakAkses?.update ? (
                              <button
                                onClick={() => resendToSAP(item['id'])}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                title={t('sentSAP')}
                              >
                                <i className='fas fa-sync-alt'></i>
                              </button>
                            ) : (
                              ''
                            )}
                            {hakAkses?.print && item.sap_number != null && (
                              <button
                                onClick={() =>
                                  handleCheckFile(
                                    `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/sales-order/print/proforma-invoice/${item.id}?lang=${i18next.language}`
                                  )
                                }
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                title={t('Proforma Invoice')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/printer-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            )}
                            <button
                              onClick={() => {
                                handleGetComment(item.id)
                              }}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              title={t('Comment')}
                              hidden={hakAkses?.read ? false : true}
                            >
                              <KTSVG
                                path='/media/icons/duotune/chat-left-text-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          </div>
                        </td>
                      </tr>

                      <tr className='fold' id={'target' + item['id']}>
                        <TableUI.TableDetail colSpan={16}>
                          <TableUI.TableWrapper style={{marginBottom: 0}}>
                            <TableUI.Table>
                              <TableUI.THead>
                                <tr style={{backgroundColor: '#274070'}}>
                                  <th>{t('kontrak-item')}</th>
                                  <th>Sales Org</th>
                                  <th>{t('kontrak-incoterm')}</th>
                                  <th>{t('kontrak-wilayah')}</th>
                                  {(item?.sector_id == 1 || item?.sector_id == 3) && (<th>{t('sub-order-endUser')}</th>)}
                                  <th>{t('Product Type')}</th>
                                  <th>{t('Product Code')}</th>
                                  <th>{t('Product Name')}</th>
                                  <th>{t('quantumapproved')}</th>
                                  {!isRetail(item.sector_id) ? <th>{t('Shipping Tolerance')}</th> : ''}
                                  <th>{t('quantumso')}</th>
                                  <th>{t('quantumsisa')}</th>
                                  <th>{t('quantumrealized')}</th>
                                  <th>{t('Price')}</th>
                                  <th>{t('kontrak-hargaPPN')}</th>
                                  <th>{t('kontrak-ppn')}</th>
                                  <th>{t('kontrak-hargaSPPN')}</th>
                                  <th>{t('Plant')}</th>
                                  <th>{t('Route')}</th>
                                  <th>Status</th>
                                  <th>{t('order-aksi')}</th>
                                </tr>
                              </TableUI.THead>
                              <TableUI.TBody>
                                {item['so_items']?.map((subItem: any, index: number) => (
                                  <tr key={subItem?.id ?? index}>
                                    <td>{index + 1}</td>
                                    <td>{subItem.order_sub_detail?.produsen?.name}</td>
                                    {isRetail(subItem.order_sub_detail?.sector?.id) ? (
                                      <>
                                        {subItem.incoterm2 == null ? (
                                          <td>{subItem.incoterm1?.code}</td>
                                        ) : (
                                          <td>
                                            {subItem.incoterm1?.code}-{subItem.incoterm2}
                                          </td>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {subItem.incoterm2 == null ? (
                                          <td>{subItem.incoterm1?.code}</td>
                                        ) : (
                                          <td>
                                            {subItem.incoterm1?.code}-{subItem.incoterm2}
                                          </td>
                                        )}
                                      </>
                                    )}
                                    <td>
                                      {subItem.order_sub_detail?.province?.region_name}
                                      {subItem.order_sub_detail?.city?.city_name
                                        ? ', ' + subItem.order_sub_detail?.city?.city_name
                                        : ''}
                                    </td>
                                    {(item?.sector_id == 1 || item?.sector_id == 3) && (
                                      <td>
                                        <div>
                                          <PopoverText
                                            content={subItem?.order_sub_detail?.end_user}
                                            index={index}
                                            className='desc-slicee'
                                          />
                                        </div>
                                      </td>
                                    )}
                                    <td>{subItem.order_sub_detail?.product_type_desc}</td>
                                    <td>
                                      {parseInt(subItem.order_sub_detail?.material_number) == 0
                                        ? ''
                                        : subItem.order_sub_detail?.material_number?.slice(-7)}
                                    </td>
                                    <td>{subItem.order_sub_detail?.product_name}</td>
                                    <td>
                                      {i18next.language === 'en'
                                        ? subItem?.order_sub_detail?.quantum_contract?.toLocaleString(
                                            'en',
                                            {maximumFractionDigits: 4}
                                          )
                                        : subItem?.order_sub_detail?.quantum_contract?.toLocaleString(
                                            'id',
                                            {maximumFractionDigits: 4}
                                          )}{' '}
                                      {subItem.order_sub_detail?.product_type != '8105'
                                        ? subItem?.order_sub_detail?.sector_id === 3
                                          ? 'MT'
                                          : 'Ton'
                                        : subItem?.order_sub_detail?.unit}
                                    </td>
                                    {item.sector_id == 1 || item.sector_id == 3 ? (
                                      <td>
                                        {subItem?.order_sub_detail?.shipping_tolerance == 0
                                          ? ''
                                          : subItem?.order_sub_detail?.shipping_tolerance + '%'}
                                      </td>
                                    ) : (
                                      ''
                                    )}
                                    <td>
                                      {i18next.language === 'en'
                                        ? subItem?.quantity?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : subItem?.quantity?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}{' '}
                                      {subItem.order_sub_detail?.product_type != '8105'
                                        ? subItem?.order_sub_detail?.sector_id === 3
                                          ? 'MT'
                                          : 'Ton'
                                        : subItem?.order_sub_detail?.unit}
                                    </td>
                                    <td>
                                      {i18next.language === 'en'
                                        ? subItem?.order_sub_detail?.left_over_quantum_no_st?.toLocaleString(
                                            'en',
                                            {maximumFractionDigits: 4}
                                          )
                                        : subItem?.order_sub_detail?.left_over_quantum_no_st?.toLocaleString(
                                            'id',
                                            {maximumFractionDigits: 4}
                                          )}{' '}
                                      {subItem.order_sub_detail?.product_type != '8105'
                                        ? subItem?.order_sub_detail?.sector_id === 3
                                          ? 'MT'
                                          : 'Ton'
                                        : subItem?.order_sub_detail?.unit}
                                    </td>
                                    <td>
                                      {i18next.language === 'en'
                                        ? subItem?.order_sub_detail?.so_qty_realized?.toLocaleString(
                                            'en',
                                            {maximumFractionDigits: 4}
                                          )
                                        : subItem?.order_sub_detail?.so_qty_realized?.toLocaleString(
                                            'id',
                                            {maximumFractionDigits: 4}
                                          )}{' '}
                                      {subItem.order_sub_detail?.product_type != '8105'
                                        ? subItem?.order_sub_detail?.sector_id === 3
                                          ? 'MT'
                                          : 'Ton'
                                        : subItem?.order_sub_detail?.unit}
                                    </td>
                                    <td>
                                      {subItem.price == 0 || subItem.price == null ? (
                                        <>
                                          {(item.sector_id != 3 ? 'Rp ' : 'USD ') +
                                            (i18next.language === 'en'
                                              ? subItem?.order_sub_detail?.fixed_price?.toLocaleString(
                                                  'en',
                                                  {maximumFractionDigits: 4}
                                                )
                                              : subItem?.order_sub_detail?.fixed_price?.toLocaleString(
                                                  'id',
                                                  {maximumFractionDigits: 4}
                                                ))}
                                        </>
                                      ) : (
                                        <>
                                          {(item.sector_id != 3 ? 'Rp ' : 'USD ') +
                                            (i18next.language === 'en'
                                              ? subItem?.price?.toLocaleString('en', {
                                                  maximumFractionDigits: 4,
                                                })
                                              : subItem?.price?.toLocaleString('id', {
                                                  maximumFractionDigits: 4,
                                                }))}
                                        </>
                                      )}
                                      /
                                      {subItem.order_sub_detail?.product_type != '8105'
                                        ? item.sector_id != 3
                                          ? 'Ton'
                                          : 'MT'
                                        : subItem?.order_sub_detail?.unit}
                                    </td>
                                    <td>
                                      {(item.sector_id != 3 ? 'Rp ' : 'USD ') +
                                        (i18next.language === 'en'
                                          ? subItem.price_before_ppn?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : subItem.price_before_ppn?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }))}
                                    </td>
                                    <td>{subItem.ppn}%</td>
                                    <td>
                                      {(item.sector_id != 3 ? 'Rp ' : 'USD ') +
                                        (i18next.language === 'en'
                                          ? subItem.price_after_ppn?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : subItem.price_after_ppn?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }))}
                                    </td>
                                    <td>{subItem.plant + " - " + subItem.plant_desc}</td>
                                    <td>{subItem.route_desc}</td>
                                    <td>
                                      <BadgeColorSO
                                        text={subItem.status_text}
                                        status={subItem.status}
                                        role={roleUser}
                                        approved_level={item?.approved_level}
                                      />
                                    </td>
                                    <td>
                                      <div className='d-flex justify-content-center'>
                                        <button
                                          onClick={() => {
                                            setTempDetail(subItem)
                                            setShowDetail(true)
                                          }}
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          data-bs-toggle='tooltip'
                                          data-bs-placement='top'
                                          data-bs-trigger='hover'
                                          title='Detail'
                                          hidden={hakAkses?.read ? false : true}
                                        >
                                          <KTSVG
                                            path='/media/icons/duotune/file-text-fill.svg'
                                            className='svg-icon-3'
                                          />
                                        </button>
                                        <button
                                          onClick={() => {
                                            setFileBox(subItem.order_sub_detail)
                                            setParam('so-item')
                                            ambilAttachment(subItem?.id, 'so-item')
                                            setSektorId(subItem.order_sub_detail.sector_id)
                                            setSONumber(item.so_number)
                                            setIDItem(subItem?.id)
                                            setShowUpload(true)
                                          }}
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          data-bs-toggle='tooltip'
                                          data-bs-placement='top'
                                          data-bs-trigger='hover'
                                          title={t('order-lampiran')}
                                        >
                                          <KTSVG
                                            path='/media/icons/duotune/archive-fill.svg'
                                            className='svg-icon-3'
                                          />
                                        </button>
                                        {item.order_sub.regarding == 'PO001' ? (
                                          <button
                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                            data-bs-toggle='tooltip'
                                            data-bs-placement='top'
                                            data-bs-trigger='hover'
                                            title={t('Jadwal')}
                                            onClick={() => {
                                              setTipeProduct(subItem.order_sub_detail.product_type)
                                              setUnitProduct(subItem.order_sub_detail.unit)
                                              setSektorId(subItem.order_sub_detail.sector_id)
                                              setProvinceName(
                                                subItem.order_sub_detail.province?.region_name
                                              )
                                              setCityName(subItem.order_sub_detail.city?.city_name)
                                              setProductName(subItem.order_sub_detail.product_name)
                                              formattingTon(subItem.order_sub_detail.fixed_quantum)
                                              setOrderSubID(
                                                subItem.order_sub_detail?.order_sub_item_id == null
                                                  ? subItem.order_sub_detail?.id
                                                  : subItem.order_sub_detail?.order_sub_item_id
                                              )
                                              setShowJadwal(true)
                                            }}
                                          >
                                            <KTSVG
                                              path='/media/icons/duotune/calendar-check-fill.svg'
                                              className='svg-icon-3'
                                            />
                                          </button>
                                        ) : (
                                          ''
                                        )}
                                        <DocFlow
                                          id={
                                            subItem.order_sub_detail.order_sub_item_id == null
                                              ? subItem.order_sub_detail?.id
                                              : subItem.order_sub_detail?.order_sub_item_id
                                          }
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </TableUI.TBody>
                            </TableUI.Table>
                          </TableUI.TableWrapper>
                        </TableUI.TableDetail>
                      </tr>
                    </Fragment>
                  ))
                )}
              </TableUI.TBody>
            </TableUI.Table>
          </TableUI.TableWrapper>
        </>
      )}

      <Modal
        size='lg'
        show={showUpload}
        onHide={() => {
          setAllFiles([])
          setShowUpload(false)
          setFileBox({})
        }}
        backdrop='static'
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {fileBox?.product_name
              ? (fileBox.province ? fileBox.province?.region_name : '') +
                (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
                (fileBox.province ? ' | ' : '') +
                fileBox.product_name +
                (fileBox.request_quantum ? ' | ' + fileBox.request_quantum + ' Ton' : '')
              : t('File Box')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isFetching ? (
            <SkeletonModal length={2} />
          ) : fetchingError ? (
            <div>{fetchingError}</div>
          ) : (
            <>
              {!downloadOnly ? (
                <>
                  <Row>
                    <Col sm={6}>
                      <table className='mb-3'>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('order-fileUnggah')}</h6>
                          </td>
                          <td className='w-75'>
                            <InputFile
                                setFileName={setNamaFile}
                                setFiles={setFiles}
                                isBase64={false}
                            />
                          </td>
                        </tr>
                      </table>
                      <table className='mb-3'>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('order-keterangan')}</h6>
                          </td>
                          <td className='w-75'>
                            <Form.Control
                              type='text'
                              placeholder={t('order-keterangan')}
                              id='uploadketerangan'
                              onChange={(e: any) => setDescription(e.target.value)}
                            />
                          </td>
                        </tr>
                      </table>
                      <table
                        className='mb-3'
                        hidden={roleUser == 'null' || roleUser == null ? true : false}
                      >
                        <tr>
                          <td>
                            <h6 className='me-11'>{t('Private')}</h6>
                          </td>
                          <td className='w-75 d-flex justify-content-start'>
                            <Form.Check
                              reverse
                              name='isPrivate'
                              type='checkbox'
                              className='mt-5 mb-2'
                              onClick={() => {
                                setIsPrivate(!isPrivate)
                                setTempRole([])
                              }}
                              id='isPrivate'
                            />
                          </td>
                        </tr>
                      </table>
                      <table className='mb-3' hidden={isPrivate ? false : true}>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('Akses Role')}</h6>
                          </td>
                          <td className='w-75' style={{maxWidth: '274px'}}>
                            <MultiSelect
                              key={isPrivate.toString()}
                              options={fullRole?.map((item: any) => {
                                return {label: item.label, value: item.value}
                              })}
                              value={tempRole}
                              onChange={(e: any) => setTempRole(e)}
                              labelledBy='Select'
                            />
                          </td>
                        </tr>
                      </table>
                      <Button
                        variant='primary'
                        className='w-100'
                        onClick={() => handleUpload(idItem)}
                        disabled={btnLoading}
                      >
                        {btnLoading ? (
                          <Spinner animation='border' variant='light' size='sm' />
                        ) : (
                          t('order-kirim')
                        )}
                      </Button>
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}
              {allFile.length < 1 || allFile.length == undefined ? (
                <></>
              ) : (
                <>
                  <div className='table-responsive mt-4 bdr' style={{marginTop: '3rem'}}>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      <thead className='border-bottom fw-bold'>
                        <tr className=''>
                          <th className='text-center'>{t('order-noo')}</th>
                          <th className='text-center'>{t('order-keterangan')}</th>
                          <th className='text-center'>{t('order-tglUpload')}</th>
                          {/* <th className='text-center'>{t('User Code')}</th> */}
                          <th className='text-center'>{t('order-user')}</th>
                          <th className='text-center'>{t('Akses Role')}</th>
                          <th className='text-center'>{t('order-aksi')}</th>
                        </tr>
                      </thead>
                      {allFile.map((data: any, _index: any) => (
                        <tbody key={data?.id ?? _index}>
                          <tr className=''>
                            <td className='text-center'>
                              <label>{_index + 1}</label>
                            </td>
                            <td className='text-center'>
                              <label>{data.description}</label>
                            </td>
                            <td className='text-center'>
                              <label>{dateformat(data.updated_at)}</label>
                            </td>
                            {/* <td className='text-center'>
                              <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                            </td> */}
                            <td className='text-center'>
                              {data.user?.customer_code == null ? (
                                <label>{data.user?.name}</label>
                              ) : (
                                <label>{data.user?.customer?.name}</label>
                              )}
                            </td>
                            <td className='text-center'>
                              {data.private ? (
                                data.roles.length > 0 ? (
                                  <PopoverText
                                    content={handleShowRoleName(data.roles)}
                                    index={_index}
                                    className='desc-slice'
                                  />
                                ) : (
                                  'Private'
                                )
                              ) : (
                                'Public'
                              )}
                            </td>
                            <td className='text-center'>
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('unduh')}
                                onClick={() =>
                                  handleDownloadAttachment(
                                    data.file_path
                                  )
                                }
                              >
                                <KTSVG
                                  path='/media/icons/duotune/arrow-down-square-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                              {(hakAkses?.attachment_delete ||
                                CheckSameIDAttachment(data.user_role_flag)) && (
                                <button
                                  onClick={() => deleteAttachment(data.id)}
                                  className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('Hapus')}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/trash-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      ))}
                    </table>
                  </div>
                </>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>
      <Modal
        show={showDate}
        onHide={() => setShowDate(false)}
        backdrop='static'
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {dateType == 'duedate' ? t('Update Due Date') : t('Update Latest Contact')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Calendar
              className='w-100'
              defaultValue={new Date(tahun, bulan, tanggal)}
              // activeStartDate={new Date(tahun, bulan, tanggal)}
              onChange={setDate}
            />
            <Button
              variant='primary'
              className='w-100 mt-2'
              onClick={() => handleTanggal()}
              disabled={btnLoading}
            >
              {btnLoading ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                t('order-kirim')
              )}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showJadwal}
        backdrop='static'
        onHide={() => setShowJadwal(false)}
        centered
        size='xl'
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {sektorId != 3 ? provinceName + ', ' + cityName + ' | ' : ''}
            {productName} | {fixedQuantum} {tipeProduct != '8105' ? 'Ton' : unitProduct}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span style={{fontSize: '15px'}} className='fw-bold d-block'>
            {t('Jadwal')}
          </span>
          <AddRemoveJadwal id={orderSubID} is_amendment={'false'} tipeproduct={tipeProduct} unit={unitProduct}/>
        </Modal.Body>
      </Modal>

      <Modal
        show={showEdit}
        onHide={() => setShowEdit(false)}
        backdrop='static'
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('ubah')} SO</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingModal ? (
            <div className='d-flex justify-content-center'>
              <Spinner animation='border' variant='primary' />
            </div>
          ) : (
            <>
              <Form.Group className='mb-3' controlId='formBasicEmail'>
                <Form.Label>{t('sub-order-kuantum')}</Form.Label>
                <CurrencyInput
                  id='jadwalton'
                  className='form-control form-control-sm'
                  placeholder={t('sub-order-kuantum')}
                  decimalSeparator={language === 'en' ? '.' : ','}
                  groupSeparator={language === 'en' ? ',' : '.'}
                  decimalsLimit={3}
                  defaultValue={quantityEdit}
                  onValueChange={(value: any) => {
                    setQuantityEdit(value?.replace(/,/g, '.'))
                  }}
                />
              </Form.Group>
              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('Price')}</Form.Label>
                <InputGroup size='sm'>
                  <InputGroup.Text>
                    {sectorId == 3 ? (
                      <span className='px-2'>USD</span>
                    ) : (
                      <span className='px-1'>Rp</span>
                    )}
                  </InputGroup.Text>
                  <CurrencyInput
                    id='jadwalton'
                    className='form-control form-control-sm'
                    placeholder={t('Price')}
                    decimalSeparator={language === 'en' ? '.' : ','}
                    groupSeparator={language === 'en' ? ',' : '.'}
                    decimalsLimit={sectorId == 3 ? 2 : -1}
                    defaultValue={priceEdit}
                    onValueChange={(value: any) => {
                      setPriceEdit(value?.replace(/,/g, '.'))
                    }}
                  />
                </InputGroup>
              </Form.Group>
              <div className='d-flex justify-content-end'>
                <Button
                  className='btn btn-primary'
                  disabled={btnLoading ? true : false}
                  onClick={submitEdit}
                >
                  {btnLoading ? (
                    <Spinner animation='border' variant='light' size='sm' />
                  ) : (
                    t('Save')
                  )}
                </Button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal show={show5} onHide={handleClose5} centered backdrop='static'>
        <Modal.Header closeButton>
          <Modal.Title>{t('Create Clearing Manual')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className='mb-3'>
            <Col md={4}>
              <Form.Label className='mt-3'>{t('Kode-booking')}</Form.Label>
            </Col>
            <Col md={8}>
              <Form.Control
                type='text'
                placeholder={t('Kode-booking')}
                onChange={(e: any) => setBookingCode(e.target.value)}
              />
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col md={4}>
              <Form.Label className='mt-3'>{t('pengirim')}</Form.Label>
            </Col>
            <Col md={8}>
              <Form.Control
                type='text'
                placeholder={t('pengirim')}
                onChange={(e: any) => setPengirim(e.target.value)}
              />
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col md={4}>
              <Form.Label className='mt-3'>{ t('mataUang') }</Form.Label>
            </Col>
            <Col md={8}>
              <Form.Select
                aria-label='Default select example'
                onChange={(e: any) => setCurrency(e.target.value)}
              >
                <option>~{t('pilih')} {t('mataUang')}~</option>
                {['IDR', 'USD'].map((item: any, index: number) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col md={4}>
              <Form.Label className='mt-3'>Bank</Form.Label>
            </Col>
            <Col md={8}>
              <Form.Select
                disabled={loadingBank}
                aria-label='Default select example'
                onChange={(e: any) => setBankId(e.target.value)}
              >
                <option>~{t('pilih')} Bank~</option>
                {bank.map((item: any, index: number) => (
                  <option key={item?.id ?? index} value={item.id}>
                    {item.name.toUpperCase()}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col md={4}>
              <Form.Label className='mt-3'>{t('Tanggal-pembayaran')}</Form.Label>
            </Col>
            <Col md={8}>
              <Form.Control
                type='date'
                placeholder={t('Tanggal-pembayaran')}
                onChange={(e: any) => setTanggalPembayaran(e.target.value)}
              />
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col md={4}>
              <Form.Label className='mt-3'>{t('Jumlah')}</Form.Label>
            </Col>
            <Col md={8}>
              <CurrencyInput
                className='form-control form-control-md'
                placeholder={t('Jumlah')}
                decimalSeparator={language === 'en' ? '.' : ','}
                groupSeparator={language === 'en' ? ',' : '.'}
                onValueChange={(value: any) => {
                  setAmount(handleFormat(value))
                }}
                decimalsLimit={3}
              />
            </Col>
          </Row>
          <div className='d-flex justify-content-end'>
            <button disabled={btnLoading} className='btn btn-primary' onClick={postBank}>
              {btnLoading ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                t('order-kirim')
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showDetail}
        onHide={() => {
          setShowDetail(false)
        }}
        centered
        scrollable
        backdrop='static'
        size={'xl'}
      >
        <Modal.Header closeButton>
          <Modal.Title>Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md='6'>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>Sales Org</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={tempDetail?.order_sub_detail?.produsen?.name}
                    type='text'
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={tempDetail?.order_sub_detail?.incoterm1?.code}
                    type='text'
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col sm={4}>
                  <p className='mt-3 fs-6'>{
                    isRetail(tempDetail?.order_sub_detail?.sector_id) ? t('pickup-province') : t('sub-order-provinsi')}
                  </p>
                </Col>
                <Col sm={8}>
                  <Form.Control
                    type='text'
                    size='sm'
                    value={tempDetail?.order_sub_detail?.province?.region_name}
                    disabled
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={tempDetail?.order_sub_detail?.product_type_desc}
                    type='text'
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              {isRetail(tempDetail?.order_sub_detail?.sector_id) && (
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('provinsi-tujuan')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={tempDetail?.order_sub_detail?.province_dest?.region_name || '-'}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
              )}
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={
                      (i18next.language === 'en'
                        ? parseFloat(tempDetail.quantity).toLocaleString('en', {
                            maximumFractionDigits: 4,
                          })
                        : parseFloat(tempDetail.quantity).toLocaleString('id', {
                            maximumFractionDigits: 4,
                          })) + (tempDetail.sector_id === 3 ? ' MT' : ' Ton')
                    }
                    type='text'
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col sm={4} className='d-flex align-items-center'>
                  <p className='fs-6'>{t('Shipping Tolerance')}</p>
                </Col>
                <Col sm={8}>
                  <Form.Control
                    // placeholder={t('Shipping Tolerance')}
                    size='sm'
                    type='text'
                    id='shipping'
                    value={
                      tempDetail?.order_sub_detail?.shipping_tolerance == 0
                        ? ''
                        : tempDetail?.order_sub_detail?.shipping_tolerance + '%'
                    }
                    disabled
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={tempDetail?.order_sub_detail?.payment_type_1_desc}
                    type='text'
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              {!isRetail(tempDetail?.order_sub_detail?.sector_id) && (
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('End Customer')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={
                        tempDetail?.order_sub_detail?.end_user_multiple
                          ? handleShowValue(tempDetail?.order_sub_detail?.end_user)
                          : tempDetail?.order_sub_detail?.end_user
                      }
                      as='textarea'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
              )}
              {isRetail(tempDetail?.order_sub_detail?.sector_id) && (
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('commodity')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={tempDetail?.order_sub_detail?.commodity || ''}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
              )}
            </Col>
            <Col md='6'>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={t(tempDetail?.order_sub_detail?.sector?.name)}
                    type='text'
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                </Col>
                <Col md={8}>
                  {tempDetail?.order_sub_detail?.incoterm2 == null ? (
                    <Form.Control
                      value={
                        tempDetail?.order_sub_detail?.incoterm2_id == null ||
                        tempDetail?.order_sub_detail?.incoterm2_id == '0'
                          ? ''
                          : tempDetail?.order_sub_detail?.incoterm2_id
                      }
                      type='text'
                      disabled
                      size='sm'
                    />
                  ) : (
                    <Form.Control
                      value={tempDetail?.order_sub_detail?.incoterm2?.code}
                      type='text'
                      disabled
                      size='sm'
                    />
                  )}
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>
                    {isRetail(tempDetail?.order_sub_detail?.sector_id) ? t('pickup-city') : t('sub-order-kota')}
                  </p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    type='text'
                    value={tempDetail?.order_sub_detail?.city?.city_name}
                    size='sm'
                    disabled
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={tempDetail?.order_sub_detail?.product_name}
                    type='text'
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              {isRetail(tempDetail?.order_sub_detail?.sector_id) && (
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('destination-city')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={tempDetail?.order_sub_detail?.city_dest?.city_name || '-'}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
              )}
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='fs-6 mt-3'>{t('Harga Pengajuan')}/Ton</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={
                      (tempDetail?.order_sub_detail?.sector_id === 3 ? 'USD ' : 'Rp ') +
                      PriceFormater(
                        tempDetail?.price || tempDetail?.order_sub_detail?.price_contract
                      )
                    }
                    type='text'
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                </Col>
                <Col md={8}>
                  <FieldProductSpec
                    data={tempDetail?.product_spec || tempDetail?.order_sub_detail?.product_spec}
                    type='editor'
                  />
                </Col>
              </Row>
              {!isRetail(tempDetail?.order_sub_detail?.sector_id) && (
                <>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.order_sub_detail?.payment_type_2_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row
                    className='mb-4'
                    hidden={tempDetail?.order_sub_detail?.sector_id == 3 ? true : false}
                  >
                    <Col md={4}>
                      <p className='fs-6 mt-3'>{t('segment')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={t(tempDetail?.order_sub_detail?.segment_name)}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                </>
              )}
              <Row className='mb-4'>
                <Col md={4} className='d-flex align-items-center'>
                  <p className='fs-6'>{t('keterangan')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={tempDetail?.order_sub_detail?.payment_note}
                    type='text'
                    as='textarea'
                    style={{height: '40px'}}
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={tempDetail?.order_sub_detail?.notes}
                    type='text'
                    as='textarea'
                    style={{height: '40px'}}
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              {!isRetail(tempDetail?.order_sub_detail?.sector_id) && (
                <>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.order_sub_detail?.amandement_notes}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.order_sub_detail?.extension_date}
                        type={tempDetail?.order_sub_detail?.extension_date ? 'date' : 'text'}
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                </>
              )}
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal
        show={showCommentCust}
        onHide={() => setShowCommentCust(false)}
        centered
        backdrop='static'
        size='lg'
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Comment')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isFetching ? (
            <SkeletonModal />
          ) : fullcomment?.length < 1 ? (
            <div>{t('No Comment')}</div>
          ) : (
            <div className='table-responsive mt-10 bdr'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bold w-100 align-items-center'>
                    <th className='td-3 text-center'>{t('no')}</th>
                    <th className='td-3 text-center'>{t('order-tanggal')}</th>
                    <th className='td-3 text-center'>{t('order-user')}</th>
                    <th className='td-3 text-center'>Status</th>
                    <th className='td-3 text-center'>{t('Comment')}</th>
                  </tr>
                </thead>
                {fullcomment?.map((item: any, _index: number) => (
                  <tbody key={item?.id ?? _index}>
                    <tr className='w-100 align-items-center'>
                      <td className='td-150 text-center'>{_index + 1}</td>
                      <td className='td-150 text-center'>{item.created_at?.slice(0, 10)}</td>
                      <td className='td-150 text-center'>{item.user?.name}</td>
                      <td className='td-150 text-center'>
                        {item.type == 8 ? t('order-revisi') : item.type == 9 ? t('Ditolak') : ''}
                      </td>
                      <td className='td-60 text-center text-truncate'>
                        <PopoverText content={item.comment} index={_index} className='desc-slice' />
                      </td>
                    </tr>
                  </tbody>
                ))}
              </table>
              {/* End Table Head */}
            </div>
          )}
        </Modal.Body>
      </Modal>

      <Pagination paginate={paginateNumber} test={numberURL} />
    </StyledCard>
  )
}

export {SOTable}
